import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsVideoThumbnailNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 1.531C4 .591 5.084.066 5.822.648l8.193 6.469c.57.45.57 1.315 0 1.766L5.822 15.35A1.125 1.125 0 014 14.468zm1.25.258v12.42L13.116 8z"
        fill=""
      />
    </svg>
  )
);
SvgActionsVideoThumbnailNormalXsmall.defaultProps = {
  color: "currentColor",
  size: 16,
  title: undefined,
  titleId: undefined,
};
SvgActionsVideoThumbnailNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsVideoThumbnailNormalXsmall;
